var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"SectionPriceProcess"}},[_c('Wrap',{staticClass:"lg"},[_c('h2',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t('title'))+" ")]),_c('div',{staticClass:"block process"},[_c('Pic',{attrs:{"alt":"Bigbank calculator","draggable":"false","src":"../../assets/process.png"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }